module.exports = __webpack_public_path__ + "img/berater_background.75584149.jpg";